/* eslint-disable react-hooks/exhaustive-deps */

import { Grid, Tooltip } from "@material-ui/core"
import { Modal, InputTextMaster, MasterButton } from "App/Component/ui"
import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance3,
  instance4,
} from "App/constants"
import {
  convertToValidPrice,
  defaultToastError,
  defaultToastSuccess,
  formatRupiah,
  isNull,
  titleModal,
} from "App/utils/helpers"
import React, { useContext, useEffect, useState } from "react"
import {
  getTotal,
  getTotalFilterID,
  hitungDiskon,
  isExist,
  usePembulatanPenjualan,
} from "../.."
import { numberToFixed } from "../.."
import { FormContext } from "../../../context/FormContext"
import { v4 as uuidv4 } from "uuid"
import { MSG_NOT_MINUS } from "utils/all"
import AlertDiskon from "../../AlertDiskon"
import Refresh from "App/Assets/icons/Refresh"
import { LoadingBackdrop } from "components/atoms"

// export const urlCreateBarang = "/wmsfarmasi/gudang/requestItemMutasiGudang";

export const urlGetBarangByGudang =
  "/wmsfarmasi/inventory/listBarangPenjualanByGudang"

export const urlDelete = "/penjualan/deleteBarang"
export const urlGet = "/penjualan/listBarangByPenjualanId"

export const deleteBarangById = async (formData) => {
  try {
    const res = await instance3.post(urlDelete, formData)

    if (res.data.status === 200) {
      return {
        state: true,
        message: res.data.message,
      }
    } else {
      return {
        state: false,
        message: res.data.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const getPembulatan = async (harga) => {
  try {
    const res = await instance3.get("/penjualan/pembulatan", {
      params: {
        angka: harga,
      },
    })

    if (res.data.status === 200) {
      return {
        state: true,
        data: res.data.data,
        message: res.data.message,
      }
    } else {
      return {
        state: false,
        data: res.data.data,
        message: res.data.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const getBarangByPenjualanID = async (id) => {
  try {
    const res = await instance3.get(`${urlGet}/${id}`)
    if (res.data.status === 200) {
      return {
        state: true,
        data: res.data.data,
        message: res.data.message,
      }
    } else if (res.data.status === 204) {
      return {
        state: true,
        data: [],
        message: res.data.message,
      }
    } else {
      return {
        state: false,
        message: res.data.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const RESET_STATE_DAFTAR_BARANG = {
  id: "",
  id_barang: "",
  id_inventory: "",
  id_gudang: "",
  qty: "",
  keterangan: "",
  harga: "",
  hargaCustom: "",

  hargaCustom2: "",
  namaBarang: "",
  unit_id: "",
  kelas_id: "",
  asuransi_id: "",

  diskon: 0,
  nilai_diskon: 0, //hargapokok*diskon/100
  total_harga_pokok: 0, //hargapokok*qty
  total_harga_jual: 0, //(hargaCustom-nilai_diskon)*qty
}

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID",
    align: "left",
    minWidth: "40px",
  },
  {
    id: "name",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "qty",
    disablePadding: false,
    label: "STOK",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "hargaJual",
    disablePadding: false,
    label: "HARGA",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "namaSatuanJual",
    disablePadding: false,
    label: "SATUAN",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "namaGudang",
    disablePadding: false,
    label: "GUDANG",
    align: "left",
    minWidth: "200px",
  },
]

export const getAllBarangByKelas = async (
  formData,
  formFilter,
  pages,
  limit,
) => {
  try {
    const api = await instance4.post(urlGetBarangByGudang, {
      halaman: pages,
      jumlah: limit,
      gudang_id: formData.gudang_id,
      asuransiId: formData.asuransi_id,
      kelasId: formData.kelas_id,
      barang_name: formFilter.barang_name,
    })

    const res = api.data
    if (res.status === 200) {
      return {
        state: true,
        data: res.data,
        meta: {
          count: parseInt(res.count),
          pages: parseInt(res.halaman),
          limit: parseInt(res.jumlah),
        },
      }
    } else {
      return {
        state: false,
        data: [],
        meta: {
          count: 0,
          pages: 1,
          limit: 10,
        },
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const ModalDaftarBarang = ({
  setShowModal,
  formBarang,
  setFormBarang,
  setNewBarangDijual,
  setNewDataBarangByKelas,
}) => {
  const pembulatan = usePembulatanPenjualan()

  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT)
  const [loadingSyncHarga, setLoadingSyncHarga] = useState(false)
  const { formData, setFormData } = useContext(FormContext)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setDisabled(DISABLED_BUTTON_SUBMIT)
    try {
      if (isNull(formBarang.qty)) {
        defaultToastError("Qty harus diisi")
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
      } else if (
        isNull(formBarang.diskon) ||
        convertToValidPrice(formBarang.diskon) < 0
      ) {
        defaultToastError("Diskon tidak boleh kosong dan kurang dari 0")
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
      } else {
        if (convertToValidPrice(formBarang.qty) > 0) {
          if (isNull(formBarang.id)) {
            const checkExist = isExist(
              formData.barang,
              "id_barang",
              formBarang.id_barang,
            )

            if (checkExist) {
              setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
              return defaultToastError("Barang ini sudah ada di list")
            } else {
              await addBarang()
            }
          } else {
            const filterBarang = formData.barang.filter(
              (e) => e.id !== formBarang.id,
            )
            const newSingleBarang = setSingleBarang("UPDATE")
            const newBarang = [...filterBarang, newSingleBarang]
            if (!isNull(formData.penjualan_id)) {
              await addBarangServer(newSingleBarang, "/penjualan/updateBarang")
              setShowModal(false)
            } else {
              setNewBarangDijual(newBarang, false)
              setShowModal(false)
              defaultToastSuccess("Berhasil mengubah list barang")
            }
          }
        } else {
          if (convertToValidPrice(formBarang.qty) < 0) {
            defaultToastError(MSG_NOT_MINUS)
            setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
          } else if (convertToValidPrice(formBarang.qty) === 0) {
            defaultToastError("QTY tidak boleh 0")
            setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
          } else if (isNull(formBarang.hargaCustom)) {
            defaultToastError("Harga harus diisi")
            setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
          } else {
            defaultToastError("Inputan tidak valid")
            setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
          }
        }
      }
    } catch (error) {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
      defaultToastError(error?.response?.data?.message)
    }
  }

  useEffect(() => {
    setFormBarang({
      ...formBarang,
      hargaCustom: convertToValidPrice(formBarang.hargaCustom2),
    })
  }, [formBarang.hargaCustom2])

  const addBarang = async () => {
    const newSingleBarang = setSingleBarang("ADD")
    const newBarang = [...formData.barang, newSingleBarang]
    const reload = formData.reload_perhitungan || false

    if (!isNull(formData.penjualan_id)) {
      await addBarangServer(newSingleBarang, "/penjualan/addBarang")
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
      setShowModal(false)
    } else {
      await setFormData({
        ...formData,
        barang: newBarang,
        is_jurnal: false,
        reload_perhitungan: !reload,
      })
      defaultToastSuccess("Berhasil menambah barang")
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
      setShowModal(false)
      setNewBarangDijual(newBarang, false)
    }
  }

  const addBarangServer = async (barang, url) => {
    try {
      if (isNull(formBarang.id_barang)) {
        defaultToastError("Barang ID kosong")
      } else {
        const _hargaTotalBarang = await getTotalFilterID(
          formData.barang,
          barang.id,
          "barang",
        )

        const hargaTotalBarang =
          barang.qty * (barang.hargaCustom - barang.nilai_diskon) +
          _hargaTotalBarang

        const totalJasa = getTotal(formData.jasa, "jasa")
        const totalRikjang = getTotal(formData.rikjang, "rikjang")
        const totalFasilitas = getTotal(formData.fasilitas, "fasilitas")
        const totalPaket = getTotal(formData.paket, "paket")

        const jumlah =
          totalJasa +
          totalRikjang +
          hargaTotalBarang +
          totalFasilitas +
          totalPaket

        const potongan = formData.potongan
        const subTotal = jumlah - potongan
        const taxPercent = isNull(formData.tax_percent)
          ? 0
          : formData.tax_percent
        const taxNumber = (taxPercent / 100) * subTotal
        const total = subTotal + taxNumber

        const newBarang = {
          ...barang,
          harga: pembulatan(barang?.harga || 0),
          hargaCustom: pembulatan(barang?.hargaCustom || 0),
          penjualanId: formData.penjualan_id,
          harga_total_barang: numberToFixed(
            convertToValidPrice(hargaTotalBarang),
          ),
          total_Penjualan: numberToFixed(convertToValidPrice(jumlah)),
          sisa: numberToFixed(convertToValidPrice(total)),

          tax: taxPercent,
          jumlah_tax: numberToFixed(convertToValidPrice(taxNumber)),
          discount: numberToFixed(
            convertToValidPrice(formData.potongan / total),
          ),
          jumlah_set_discount: potongan,
          nilai_diskon: numberToFixed(barang?.nilai_diskon || 0),
          total_harga_jual:
            pembulatan(barang?.hargaCustom || 0) -
            numberToFixed(barang?.nilai_diskon || 0),
          total_harga_pokok: numberToFixed(barang?.total_harga_pokok || 0),
        }

        const res = await instance3.post(url, newBarang)
        if (res.data.status === 200) {
          defaultToastSuccess(res.data.message)
          setNewBarangDijual(newBarang, false)
          setNewDataBarangByKelas()
        } else {
          defaultToastError(res.data.message)
        }
      }
    } catch (error) {
      defaultToastError(error?.response?.data?.message)
    }
  }

  const setSingleBarang = (type) => {
    const hargaPokok = convertToValidPrice(formBarang.hargapokok)
    const diskon = parseFloat(String(formBarang.diskon).replace(",", ".")) || 0
    const qty = convertToValidPrice(formBarang.qty)
    const hargaCustom = pembulatan(convertToValidPrice(formBarang.hargaCustom))

    const { nilaiDiskon, totalHargaPokok } = hitungDiskon(formBarang, "barang")

    const singleBarang = {
      id_barang: formBarang.id_barang,
      id_inventory: formBarang.id_inventory,
      id_gudang: formBarang.id_gudang,
      qty,
      keterangan: "",
      harga: formBarang.harga,
      hargapokok: hargaPokok,
      hargaCustom: hargaCustom,
      hargaCustom2: formBarang.hargaCustom2,

      total: hargaCustom * formBarang.qty,
      namaBarang: formBarang.namaBarang,
      kelas_id: formData.kelas_id,
      asuransi_id: formData.asuransi_id,

      diskon,
      nilai_diskon: pembulatan(nilaiDiskon),
      total_harga_pokok: totalHargaPokok,
      total_harga_jual: hargaCustom - pembulatan(nilaiDiskon),
    }

    let newSingleBarang
    if (type === "ADD") {
      newSingleBarang = {
        id: uuidv4(),
        ...singleBarang,
      }
    } else {
      newSingleBarang = {
        id: formBarang.id,
        ...singleBarang,
      }
    }

    return newSingleBarang
  }

  const handleSyncHarga = async () => {
    const hargaCustom = formBarang.hargaCustom
    if (isNull(hargaCustom)) {
      defaultToastError("Harap masukkan harga !")
    } else {
      setLoadingSyncHarga(true)
      const res = await getPembulatan(hargaCustom)
      if (res.state) {
        setFormBarang({
          ...formBarang,
          hargaCustom: res.data,
          hargaCustom2: formatRupiah(res.data),
        })
        setLoadingSyncHarga(false)
      } else {
        defaultToastError(res.message)
        setLoadingSyncHarga(false)
      }
    }
  }

  return (
    <Modal title={`${titleModal(formBarang.id)} Barang`} show={setShowModal}>
      {loadingSyncHarga && (
        <>
          <LoadingBackdrop />
        </>
      )}
      <form action="POST" onSubmit={(e) => handleSubmit(e)}>
        {formBarang.id && (
          <AlertDiskon defaultDiskon={formData.diskon?.diskon_barang ?? 0} />
        )}
        <p className="mt-1 mb-1">{formBarang.namaBarang}</p>
        <Grid container spacing={1}>
          <InputTextMaster
            type="hidden"
            name="id"
            id="id"
            readOnly={true}
            value={formBarang.id}
          />
          <Grid item sm={6}>
            <InputTextMaster
              name="qty"
              label="BANYAK"
              id="qty"
              value={formBarang.qty}
              onChange={(e) => {
                let val = e.target.value
                if (!isNull(val)) {
                  setFormBarang({
                    ...formBarang,
                    qty: formatRupiah(val, false),
                  })
                } else {
                  setFormBarang({
                    ...formBarang,
                    qty: val,
                  })
                }
              }}
              placeholder="Banyak"
              autoFocus={true}
            />
          </Grid>
          <Grid item sm={6}>
            <InputTextMaster
              name="harga"
              label="HARGA"
              id="harga"
              placeholder="0"
              value={formBarang.hargaCustom2}
              onChange={(e) => {
                let val = e.target.value
                if (!isNull(val)) {
                  setFormBarang({
                    ...formBarang,
                    hargaCustom2: formatRupiah(val, false),
                  })
                } else {
                  setFormBarang({
                    ...formBarang,
                    hargaCustom2: val,
                  })
                }
              }}
              withButton
            >
              <Tooltip title="Pembulatan Harga Sesuai Pengaturan">
                <button
                  type={"button"}
                  disabled={isNull(formBarang.hargaCustom)}
                  style={{
                    borderRight: `1px solid ${
                      isNull(formBarang.hargaCustom) ? "#EAEAEA" : "#f09f00"
                    }`,
                    borderTop: `1px solid ${
                      isNull(formBarang.hargaCustom) ? "#EAEAEA" : "#f09f00"
                    }`,
                    borderBottom: `1px solid ${
                      isNull(formBarang.hargaCustom) ? "#EAEAEA" : "#f09f00"
                    }`,
                    borderLeft: `1px solid ${
                      isNull(formBarang.hargaCustom) ? "#EAEAEA" : "#f09f00"
                    }`,
                    background: isNull(formBarang.hargaCustom)
                      ? "#EAEAEA"
                      : "#f09f00",
                    cursor: isNull(formBarang.hargaCustom)
                      ? "not-allowed"
                      : "pointer",
                    padding: "0 0.8rem",
                    borderRadius: "0px 5px 5px 0px",
                  }}
                  onClick={
                    isNull(formBarang.hargaCustom)
                      ? () => {}
                      : () => handleSyncHarga()
                  }
                >
                  <Refresh
                    width="20px"
                    height="20px"
                    // style={{
                    //   marginLeft: "-0.56rem",
                    //   marginBottom: "0.2rem",
                    // }}
                  />
                </button>
              </Tooltip>
            </InputTextMaster>
          </Grid>
          <Grid item sm={6}>
            <InputTextMaster
              name="discount-barang"
              label="DISKON (%)"
              id="discount-barang"
              value={formBarang.diskon}
              onChange={(e) => {
                const raw = e.target.value
                if (raw === "") {
                  return setFormBarang({ ...formBarang, diskon: "" })
                }
                if (/^[0-9]*([.,][0-9]*)?$/.test(raw)) {
                  if (convertToValidPrice(raw) > 100) {
                    return setFormBarang({ ...formBarang, diskon: 100 })
                  } else {
                    return setFormBarang({
                      ...formBarang,
                      diskon: formatRupiah(raw),
                    })
                  }
                }
              }}
              placeholder="0-100"
              error={convertToValidPrice(formBarang.diskon) > 100}
              message="Maksimal 100%"
            />
          </Grid>
          <Grid item sm={6}>
            <InputTextMaster
              name="nilai-discount"
              label="NILAI DISKON"
              id="nilai-discount"
              value={formatRupiah(
                pembulatan(
                  convertToValidPrice(
                    (convertToValidPrice(formBarang.hargaCustom) *
                      (parseFloat(
                        String(formBarang.diskon).replace(",", "."),
                      ) || 0)) /
                      100,
                  ),
                ),
              )}
              disabled
              placeholder="Nilai Diskon"
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
        >
          <MasterButton
            className={"mt-1"}
            type="submit"
            color={disabled.color}
            name={disabled.label}
            size="md"
          />
        </Grid>
      </form>
    </Modal>
  )
}
